<!--  -->
<template>
  <div>
    <div class="select_box">
      <el-tabs v-model="pageIfon.business_type" type="card" @tab-click="handleClickgender">
        <el-tab-pane v-for="items,index in options" :key="index" :label="items.description" :name="items.value" />
      </el-tabs>
      <!-- <el-select v-model="pageIfon.gender" placeholder="请选择频道类型">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select> -->
      <!-- <el-button type="primary" style="margin-left:10px" @click="search">搜索</el-button>
      <el-button type="primary" style="margin-left:10px" @click="reash">重置</el-button> -->
    </div>
    <div class="taballbox">
      <div v-for="item,index in tableData" :key="index" style="margin-right:10px" @click="choose(item)">
        <el-image
          style="width: 100px; height: 100px"
          :src="item.path"
          fit="scale-down"
        />
      </div>
    </div>

    <!-- <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="频道"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.gender == 1">男频</el-tag>
          <el-tag v-if="scope.row.gender == 2">女频</el-tag>
          <el-tag v-if="scope.row.gender == 3">默认</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="图片"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <img :src="scope.row.img" style="width:100px;height:100px" alt="">
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row.img)">选择</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <pagination-right
      :total="total"
      :page-sizes="[pageIfon.pageSize]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { getMaterialLibraryList, promotionmaterialtypelist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      pageIfon: {
        type: 1,
        page: 1,
        pageSize: 18,
        is_public: 1,
        business_type: 12
      },
      options: [],
      total: null
    }
  },
  created() {
    this.imfawr()
    this.promotionmaterialtypelistall()
  },
  mounted() {

  },
  methods: {
    async promotionmaterialtypelistall() {
      const data = await promotionmaterialtypelist()
      this.options = data.data.type_list
      console.log('data', data)
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    send(platformvalue, gender) {
      // console.log('gender', gender)
      // this.pageIfon.platform_id = platformvalue
      // this.pageIfon.gender = gender.toString()
      // this.imfawr()
      // this.promotionmaterialtypelistall()
    },
    async imfawr() {
      const data = await getMaterialLibraryList(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data111', data.data.list)
    },
    choose(img) {
      console.log('item', img)
      this.$emit('choosecontentcallback', img)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.page_size = e
      this.imfawr()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.imfawr()
    },
    search() {
      this.pageIfon.page = 1
      this.imfawr()
    },
    reash() {
      this.pageIfon.page = 1
      this.pageIfon.page_size = 10
      this.pageIfon.gender = 0
      this.imfawr()
    },
    handleClickgender(tab, event) {
      this.imfawr()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.select_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.taballbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
